import React, { useState, useRef, useEffect } from "react";

import "./Accoridion.css";
import Chevron from "./Chevron";

const Accordion = ({ title, children, isActivate }) => {
  const [active, setActive] = useState(false);

  const content = useRef();
  const sensitive = useRef();

  useEffect(() => {
    if (isActivate) {
      setActive(isActivate);
    }
  }, [isActivate]);

  const toggleAccordion = () => {
    setActive(!active)
  };

  return (
    <>
      <div className={`accordion__section relative ${active ? "active" : ""}`} ref={sensitive}>
        <button className={`accordion ${active ? "active" : ""}`} onClick={toggleAccordion}>
          <p className="accordion__title font-black">{title}</p>
          <Chevron width={10} fill={"#777"} className={`${active ? "accordion__icon rotate" : "accordion__icon"}`} />
        </button>
        <div
          ref={content}
          style={{
            marginBottom: `${active ? "20px" : "0px"}`,
          }}
          className="accordion__content"
        >
          <div className="accordion__text italic">{children}</div>
        </div>
      </div>
    </>
  );
};

export default Accordion;
